/* eslint-disable */

import $ from 'jquery'
let jQuery = $

jQuery.Event.prototype.stop = function () {
  this.preventDefault()
  this.stopPropagation()
  return false
}

// selector onscrren elements only
// (function(a){a.expr[":"].onScreen=function(b){let c=a(window),d=c.scrollTop(),e=c.height(),f=d+e,g=a(b),h=g.offset().top,i=g.height(),j=h+i;return h>=d&&h<f||j>d&&j<=f||i>e&&h<=d&&j>=f}})(jQuery);
jQuery.expr[':'].onScreen = function (elem) {
  let
    // $window = $(window),
    // vp_top = $window.scrollTop(),
    vp_top    = window.pageYOffset,
    // vp_height = $window.height(),
    vp_height = window.innerHeight,
    vp_bottom = vp_top + vp_height,
    $elem     = $(elem),
    top       = $elem.offset().top,
    height    = $elem.height(),
    bottom    = top + height

  return (top >= vp_top && top < vp_bottom) ||
    (bottom > vp_top && bottom <= vp_bottom) ||
    (height > vp_height && top <= vp_top && bottom >= vp_bottom)
};

/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 */
(function ($, c) {
  let a
  $.throttle = a = function (e, f, j, i) {
    let h, d = 0
    if (typeof f !== 'boolean') {
      i = j
      j = f
      f = c
    }
    function g () {
      let o = this, m = +new Date() - d, n = arguments

      function l () {
        d = +new Date()
        j.apply(o, n)
      }

      function k () { h = c }

      if (i && !h) { l() }
      h && clearTimeout(h)
      if (i === c && m > e) { l() } else { if (f !== true) { h = setTimeout(i ? k : l, i === c ? e - m : e) } }
    }

    if ($.guid) { g.guid = j.guid = j.guid || $.guid++ }
    return g
  }
  $.debounce = function (d, e, f) { return f === c ? a(d, e, false) : a(d, f, e !== false) }
})(jQuery)

export default $